import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@ps-gui/shared-core';

export interface AuditChatMessage {
  id: string;
  message: string;
  created: string;
  sentByClerk: boolean;
  sender: { name: string };
}

@Injectable({
  providedIn: 'root',
})
export class AuditChatApiService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.psBackendUrl;
  }

  getAuditChatMessages(proofId: string): Observable<AuditChatMessage[]> {
    return super.get(`audit/${proofId}/message`);
  }
}
